module.exports = __webpack_public_path__ + "img/2AA.1.890e8ca6.jpg";